import axios from 'axios'
import { environment } from '@/data/environment'

export const refreshToken = async () => {
  const email = JSON.parse(atob(localStorage.getItem('uid'))).user
  const span = JSON.parse(atob(localStorage.getItem('uid'))).span

  const data = { email: email, span: span }

  const endpoint = '/refreshAuth'
  const url = environment.HIOPOSWEBSERVICES + endpoint

  try {
    const response = await axios.post(url, data)
    const newToken = response.data.token
    const storedData = localStorage.getItem('uid')
    if (storedData) {
      const dataUser = JSON.parse(atob(storedData))
      dataUser.jwt = newToken
      localStorage.setItem('uid', btoa(JSON.stringify(dataUser)))
    } else {
      console.error('No se encontró el objeto en localStorage')
    }
    return newToken
  } catch (error) {
    console.error('Error al solicitar un nuevo token:', error.message)
    throw error
  }
}
